<div
  [ngClass]="{
    'wrapper--spacing-horizontal wrapper--spacing-vertical': !isMobile,
    'spacing--margin-all': isMobile,
  }"
>
  <agr-summary-card [title]="title" [canExpand]="true" [actions]="actions">
    <div>
      <ng-content select="[body]" *ngIf="!isEmpty; else emptymessage"></ng-content>
      <ng-template #emptymessage>
        <span class="text--small text--gray" *ngIf="emptyMessage !== undefined">
          {{ emptyMessage }}
        </span>
      </ng-template>
    </div>
    <ng-content *ngIf="showBottomBar" select="[bottom-bar]"></ng-content>
  </agr-summary-card>
</div>
